export default __webpack_public_path__ + "static/media/super.d05b31c0.jpg";